<crowdctrl-unauthenticated-page [pageTitle]="pageTitle" [showFooter]="false" defaultHref="/about">
  <div class="about-project">
    <crowdctrl-unauth-page-intro>
      <h1 crowdctrlUnauthIntroTitle>Register interest</h1>
      <p crowdctrlUnauthIntroLead>
        Tell us you want to hear about CrowdCTRL. We can follow up on access, onboarding, or how it
        fits your organisation.
      </p>
    </crowdctrl-unauth-page-intro>

    <section class="about-project__section" aria-labelledby="ri-summary">
      <h2 id="ri-summary" class="about-project__heading">What this page is for</h2>
      <p class="about-project__text">
        Send your name and email (and optional details) so we can follow up. If you already have an
        account,
        <a
          href="/login"
          class="about-project__inline-link"
          (click)="unauthNav.forward($event, '/login')"
          >sign in here</a
        >.
      </p>
    </section>

    @if (showInlineForm) {
      <crowdctrl-form-layout
        heading="Your details"
        headingId="ri-form"
        [errorMessage]="errorMessage"
      >
        <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" novalidate>
          <div class="crowdctrl-form-fields">
            <crowdctrl-form-input-field
              controlName="name"
              label="Name"
              autocomplete="name"
              autocapitalize="sentences"
              [maxlength]="maxNameLen"
              inputmode="text"
              [invalid]="submitted && registerForm.controls.name.invalid"
              [hint]="submitted && registerForm.controls.name.invalid ? fieldError('name') : ''"
            ></crowdctrl-form-input-field>
            <crowdctrl-form-input-field
              controlName="email"
              label="Email"
              type="email"
              autocomplete="email"
              autocapitalize="off"
              inputmode="email"
              [maxlength]="maxEmailLen"
              [invalid]="submitted && registerForm.controls.email.invalid"
              [hint]="submitted && registerForm.controls.email.invalid ? fieldError('email') : ''"
            ></crowdctrl-form-input-field>
            <crowdctrl-form-input-field
              controlName="organisation"
              label="Organisation"
              [optional]="true"
              placeholder="Enter organisation name"
              autocomplete="organization"
              autocapitalize="sentences"
              [maxlength]="maxOrgLen"
              inputmode="text"
              [invalid]="submitted && registerForm.controls.organisation.invalid"
              [hint]="
                submitted && registerForm.controls.organisation.invalid
                  ? fieldError('organisation')
                  : ''
              "
            ></crowdctrl-form-input-field>
            <crowdctrl-form-textarea-field
              controlName="message"
              placeholder="Anything else you'd like us to know (optional)"
              autocapitalize="sentences"
              [rows]="4"
              [maxlength]="maxMessageLen"
              [invalid]="submitted && registerForm.controls.message.invalid"
              [hint]="
                submitted && registerForm.controls.message.invalid ? fieldError('message') : ''
              "
            ></crowdctrl-form-textarea-field>
          </div>
          <ion-note class="crowdctrl-form-layout__note">
            This site is protected by reCAPTCHA and the Google
            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer"
              >Privacy Policy</a
            >
            and
            <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer"
              >Terms of Service</a
            >
            apply.
          </ion-note>
          <crowdctrl-form-actions>
            <crowdctrl-loading-button
              type="submit"
              expand="block"
              [loading]="submitting"
              loadingText="Submitting..."
            >
              Submit
            </crowdctrl-loading-button>
          </crowdctrl-form-actions>
        </form>
      </crowdctrl-form-layout>
    } @else if (registerInterestUrl) {
      <p class="about-project__text">
        <a
          [href]="registerInterestUrl"
          class="about-project__signin-link"
          target="_blank"
          rel="noopener noreferrer"
          >Open registration form (opens in a new tab)</a
        >
      </p>
    } @else {
      <section class="about-project__section" aria-labelledby="ri-no-form">
        <h2 id="ri-no-form" class="about-project__heading">No form on this deployment</h2>
        <p class="about-project__text">
          Configure <code>apiUrl</code> and <code>recaptchaSiteKey</code> for this app, or set a
          public registration URL. Until then, use
          <a
            href="/contact"
            class="about-project__inline-link"
            (click)="unauthNav.forward($event, '/contact')"
            >Contact</a
          >
          to reach the team.
        </p>
      </section>
    }

    @if (showInlineForm && registerInterestUrl) {
      <p class="about-project__text">
        Prefer an external form?
        <a
          [href]="registerInterestUrl"
          class="about-project__inline-link"
          target="_blank"
          rel="noopener noreferrer"
          >Open registration form (new tab)</a
        >
      </p>
    }

    <a
      href="/login"
      class="about-project__signin-link"
      (click)="unauthNav.forward($event, '/login')"
      >Sign in</a
    >
  </div>
</crowdctrl-unauthenticated-page>
